import * as React from 'react';

// Clean refresh / reload glyph. Uses `currentColor` so the icon inherits
// the surrounding text color (button label, antd Icon wrapper, etc.) —
// consumers that want the legacy BEEM blue can wrap in a colored span
// or pass `color="#0067f4"` via styled-components.
// viewBox lets the icon scale crisply when CSS width/height are
// overridden by a constraining wrapper.
export default (props) => (
  <svg
    width={props.width || 18}
    height={props.height || 18}
    viewBox="0 0 24 24"
    fill="none"
    stroke={props.color || 'currentColor'}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 12a9 9 0 0 1 15.5-6.3" />
    <path d="M21 4v5h-5" />
    <path d="M21 12a9 9 0 0 1-15.5 6.3" />
    <path d="M3 20v-5h5" />
  </svg>
);
